<template>
  <div>
    <section id="home" class="slider-area fix p-relative">
      <div id="parallax" class="slider-active" style="background: #141b22">
        <div
          class="single-slider slider-bg"
          :style="{
            backgroundImage: `url(${require('@/assets/img/slider/slider_bg.png')})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center bottom',
          }"
        >
          <!-- <div class="slider-shape ss-one layer" data-depth="0.30">
            <img src="@/assets/img/slider/slider_shape01.png" alt="shape" />
          </div> -->
          <div class="container">
            <div class="row">
              <div class="col-lg-7 col-md-7">
                <div class="slider-content s-slider-content mt-80">
                  <h2 data-animation="fadeInUp" data-delay=".4s" style="color:#2C5C9E">
                    {{ cms?.mainSection?.subHeading }}
                    {{ cms?.mainSection?.mainHeading  }}
                  </h2>
                  <p data-animation="fadeInUp" data-delay=".6s">
                    {{ cms?.mainSection?.subDesc }}
                    {{ cms?.mainSection?.mainDesc }}
                  </p>

                  <div class="slider-btn mt-50">
                    <router-link to="/courses" custom v-slot="{ navigate }">
                      <button @click="navigate" class="btn ss-btn" style="background-color:#2C5C9E">View Courses</button>
                    </router-link>

                    <!-- <a
                      class="btn ss-btn mr-15"
                      data-animation="fadeInLeft"
                      data-delay=".4s"
                      @click.prevent="handleScrollToSection('courses')"
                      >View courses
                    </a> -->
                    <div
                      class="h-call-box wow fadeInUp animated"
                      data-animation="fadeInUp"
                      data-delay=".4s"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="col-lg-5 col-md-5 p-relative"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="service-details-two p-relative">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-12 col-sm-12" style="z-index: 9">
            <div class="services-box07">
              <div class="sr-contner">
                <div class="icon">
                  <div class="img">
                    <img src="@/assets/img/icon/sve-icon4.png" alt="icon01" />
                  </div>
                  <h5><a href="about.html">Always on top</a></h5>
                </div>
                <div class="text text-left">
                  <p>
                    Our students aim to fly high! We provide real world
                    experience with polished skills to our students which helps
                    them to achieve new heights in their career.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-12 col-sm-12" style="z-index: 9">
            <div class="services-box07">
              <div class="sr-contner">
                <div class="icon">
                  <div class="img">
                    <img src="@/assets/img/icon/sve-icon5.png" alt="icon01" />
                  </div>
                  <h5><a href="about.html">Expert faculty</a></h5>
                </div>
                <div class="text text-left">
                  <p>
                    We have renowned experts in our faculty who have years of
                    experience in their respective fields. They provide the best
                    guidance to our students.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-12 col-sm-12" style="z-index: 9">
            <div class="services-box07">
              <div class="sr-contner">
                <div class="icon">
                  <div class="img">
                    <img src="@/assets/img/icon/sve-icon6.png" alt="icon01" />
                  </div>
                  <h5><a href="about.html">Modern skills</a></h5>
                </div>
                <div class="text text-left">
                  <p>
                    Our curriculum is up to date with the latest trends in the
                    industry. We provide our students with the most modern
                    skills which are in demand.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- About -->
    <section id="about" class="about-area about-p pt-120 pb-120 p-relative fix">
      <div class="container">
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-6 col-md-12 col-sm-12">
            <div
              class="about-content s-about-content pl-15 wow fadeInRight animated text-left"
              data-animation="fadeInRight"
              data-delay=".4s"
            >
              <div class="about-title second-title pb-25">
                <h5 style="color:#2C5C9E">About Archvarsity</h5>
                <h2 style="color: #2C5C9E;">{{ cms.aboutSection?.mainHeading }}</h2>
              </div>
              <p class="txt-clr">
                {{ cms.aboutSection?.mainDesc }}
              </p>
              <div class="about-content3 mt-30 mb-30">
                <div class="row">
                  <div class="col-md-6">
                    <ul class="green">
                      <li>Most in demand industries</li>
                      <li>Get highly paid jobs</li>
                    </ul>
                  </div>
                  <div class="col-md-6">
                    <ul class="green">
                      <li>Affrodable pricing</li>
                      <li>Highly accomplished teachers</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="slider-btn mt-20">
                <a href="about.html" class="btn ss-btn smoth-scroll mr-15" style="background-color:#2C5C9E"
                  >Read More</a
                >
                <div
                  class="award-btn"
                  
                >
                  <div class="img" style="color:#2C5C9E"> 
                    <img
                      src="@/assets/img/icon/award-btn-icon.png"
                      height="50"
                      alt="icon01"
                    />
                  </div>
                  Explore courses
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12">
            <div
              class="s-about-img p-relative wow fadeInLeft animated"
              data-animation="fadeInLeft"
              data-delay=".4s"
            >
              <img src="@/assets/img/features/about_img_02.png" alt="img" />
              <div class="about-text second-about text-left">
                <div class="box-text">
                  <div class="icon">
                    <img src="@/assets/img/features/ab-ani-01.png" alt="img" />
                  </div>
                  <div class="text">
                    <span>20+</span>
                    Years of exp.
                  </div>
                </div>
                <p>Learn from the industry’s most influential teachers</p>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  
    <!-- vision/mission -->
    <!-- <section
      class="services-area p-relative pt-80 pb-20"
      :style="{
        backgroundImage:
          'url(' + require('../assets/img/bg/vision-bg.jpg') + ')',
      }"
      style="background-size: cover; background-position: center bottom"
    >
      <div class="container">
        <div class="row justify-content-center align-items-center mb-120">
          <div class="col-lg-6 col-md-12 col-sm-12">
            <div class="img">
              <img
                src="../assets/img/bg/vision-front.png"
                alt="icon01"
                style="border: 3px solid #fff; border-radius: 12px"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12">
            <div class="section-title text-left">
              <h2>Vision</h2>
              <p>
                {{ cms?.vision }}
              </p>
              <br />
              <h2>Mission</h2>
              <p> {{ cms?.mission }}
               
              </p>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section
      id="courses"
      class="shop-area text-left pt-60 pb-90 p-relative"
      data-animation="fadeInUp animated"
      data-delay=".2s"
    >
      <div class="container">
        <div class="row align-items-center class-scroll">
          <div class="about-title second-title pb-25">
            <h5>Our Courses</h5>
            <h2>Latest courses at Archvarsity</h2>
          </div>
          <div v-if="courses.length === 0" class="col-lg-12 text-center">
            <p>No courses available at the moment.</p>
          </div>
          <div
            v-for="course in courses"
            :key="course._id"
            class="col-lg-4 col-md-6"
          >
            <div class="class-item mb-30">
              <div class="class-img">
                <div class="class-img-outer">
                  <a :href="`/live-course-details/${course._id}`">
                    <div
                      class="course-thumbnail"
                      :style="{ backgroundImage: `url(${course.coverImage})` }"
                    ></div>
                  </a>
                  <div class="course-meta">
                    <div class="row align-items-center">
                      <div class="col-lg-8">
                        <div class="author">
                          <div class="thumb">
                            <div
                              :style="{
                                backgroundImage: course.facilitators[0]
                                  ?.profileImage
                                  ? `url(${course.facilitators[0].profileImage})`
                                  : '',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                height: '50px',
                                width: '50px',
                                borderRadius: '50%',
                                border: '2px solid #fff',
                              }"
                            ></div>
                          </div>

                          <div class="text">
                            <a>{{ course.facilitators[0]?.firstName }}</a>
                            <p>{{ course.facilitators[0]?.title }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ul class="schedule">
                <li>
                  <span>Category</span>
                  <span class="class-size">{{ course.category }}</span>
                </li>
                <li>
                  <span>Duration</span>
                  <span class="class-size">{{ course.duration }}</span>
                </li>
                <li>
                  <span>Total Spots</span>
                  <span class="class-size">{{ course.capacity }}</span>
                </li>
              </ul>

              <div class="class-content">
                <h4 class="title">
                  {{ course.title }}
                </h4>
                <p class="mb-20">{{ course.shortSummary }}</p>
                <a
                  :href="`/live-course-details/${course._id}`"
                  class="readmore"
                >
                  View Course Details <i class="fal fa-long-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
      
            <div class="class-item mb-30">
             
              <div class="class-img">
                <div class="class-img-outer">
                  <a>
                    <img src="../assets/img/class/more.png" alt="class image"
                  /></a>
                </div>
              </div>
              <div class="class-content">
                <h4 class="title"><a>Looking for more courses?</a></h4>
                <p>
                  Please reach out to us and suggest which course you want us to
                  prepare. We give early bird opportunity to our students to
                  suggest courses they want. We work with our expert teachers to
                  research and come up with industry standard courses.
                </p>
                <a href="mailto:info@archvarsity.com" class="readmore"
                  >Contact us <i class="fal fa-long-arrow-right"></i
                ></a>
              </div>
            
            </div>
          </div>
        </div>
      </div>
    </section> -->
  
  </div>
</template>

<script>
import api from "@/services/api";
export default {
  name: "HomePage",
  data() {
    return {
      courses: [], // ✅ Store courses dynamically
      cms:{}
    };
  },
  mounted() {
    this.fetchCourses(); // ✅ Fetch courses when homepage loads
    this.fetchCMSContent();
  },
  methods: {
    handleScrollToSection(idName) {
      if (this.$route.path !== "/") {
        // Navigate to Home first
        this.$router.push("/").then(() => {
          // Wait for the page to load before scrolling
          this.$nextTick(() => {
            this.scrollToSection(idName);
          });
        });
      } else {
        // If already on Home, just scroll
        this.scrollToSection(idName);
      }
    },
    scrollToSection(sectionId) {
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); // Small delay to ensure the DOM is updated
    },
    async fetchCourses() {
      try {
        const response = await api.get("/api/courses/public");
        this.courses = response.data.courses;
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    },
    async fetchCMSContent() {
      try{
        const response = await api.get("/api/cms/");
        this.cms = response.data;
      }
      catch (err){
        console.error("Error fetching courses", err);
      }
    }
  },
};
</script>

<style scoped>
.course-thumbnail {
  height: 270px;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
</style>
